import {Env} from "@morningtrain/helpers";

export default function TitlePlugin(app) {

    const title = [Env.get('page.title'), Env.get('app.name')].filter(t => t).join(' | ');

    if (typeof document.title !== 'undefined') {
        document.title = title;
    }
}
